import { render, staticRenderFns } from "./SalesPerHourChart.vue?vue&type=template&id=22f93c1e"
import script from "./SalesPerHourChart.vue?vue&type=script&lang=js"
export * from "./SalesPerHourChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports